<template>
  <div id="app">
    <router-view />
  </div>
</template>

<style>
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  /* background: #252526; */
  color: #cccccc;
  font-size: 14px;
}

::-webkit-scrollbar {
  width: 7px !important;
  height: 5px !important;
  border-radius: 15px !important;
  -webkit-border-radius: 15px !important;
}

::-webkit-scrollbar-track-piece {
  /* background-color: #ffff !important; */
  border-radius: 15px !important;
  -webkit-border-radius: 15px !important;
}

::-webkit-scrollbar-thumb:vertical {
  height: 5px !important;
  background-color: rgba(144, 147, 153, 0.5) !important;
  border-radius: 15px !important;
  -webkit-border-radius: 15px !important;
}

::-webkit-scrollbar-thumb:horizontal {
  width: 7px !important;
  background-color: rgba(144, 147, 153, 0.5) !important;
  border-radius: 15px !important;
  -webkit-border-radius: 15px !important;
}

textarea {
  font-family: 'Microsoft YaHei', 'Avenir', Helvetica, Arial, sans-serif;
  resize: none !important;
}

#app {
  font-family: 'Microsoft YaHei', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}

.el-menu {
  background: #303133 !important;
  border-right: none !important;
}

.el-menu-item.is-active {
  color: #a2aab4 !important;
}

.el-menu-item:focus,
.el-menu-item:hover {
  background-color: #2b3139 !important;
}

.el-tabs__header {
  margin: 0 0 !important;
}

.el-tabs__nav-wrap::after {
  background: #303133 !important;
}

.el-tabs {
  height: 100% !important;
}

.el-tabs__content {
  height: calc(100% - 46px) !important;
}

.el-tab-pane {
  height: 100% !important;
  overflow-y: auto !important;
}

.el-tabs--card>.el-tabs__header .el-tabs__nav {
  border: 1px solid #303133 !important;
}

.el-tabs--card>.el-tabs__header {
  border: 1px solid #303133 !important;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
}

.el-tabs__item {
  height: 35px !important;
  line-height: 35px !important;
  font-size: 14px !important;
  padding: 0 10px !important;
  color: #666666 !important;
}

.el-tabs__item.is-active {
  color: #cccccc !important;
  background: #303133 !important;
  padding: 0 10px !important;
}

.el-tabs__active-bar {
  background-color: #303133 !important;
}

.el-tabs--card>.el-tabs__header .el-tabs__item {
  border-left: 1px solid #303133 !important;
}

.el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
  border-bottom-color: #303133 !important;
}

.el-tabs--border-card {
  background: #252526 !important;
  border: 1px solid #252526 !important;
}

.el-tabs--border-card>.el-tabs__header {
  background-color: #252526 !important;
  border-bottom: 1px solid #252526 !important;
}

.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
  color: #cccccc !important;
  background: #303133 !important;
}

.custom-popover {
  min-width: 60px !important;
  width: auto !important;
}
</style>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'

// 响应式数据
const isElectron = ref(false)
const isRefreshing = ref(false)

// 键盘事件处理函数
const handleKeydown = async (e) => {
  // Ctrl+F5 或 Ctrl+Shift+R
  if ((e.ctrlKey && e.key === 'F5') || (e.ctrlKey && e.shiftKey && e.key === 'R')) {
    e.preventDefault()
    await hardRefresh()
  }
  // F5 普通刷新
  if (e.key === 'F5') {
    e.preventDefault()
    softRefresh()
  }
}

// 硬刷新（清除缓存）
const hardRefresh = async () => {
  if (isRefreshing.value) return
  
  isRefreshing.value = true
  
  try {
    if (window.electronAPI?.clearCacheAndReload) {
      await window.electronAPI.clearCacheAndReload()
    } else {
      // 降级方案
      fallbackRefresh()
    }
  } catch (error) {
    console.error('刷新失败:', error)
    isRefreshing.value = false
    alert('刷新失败，请手动刷新页面')
  }
}

// 软刷新（不清除缓存）
const softRefresh = () => {
  if (window.electronAPI?.reload) {
    window.electronAPI.reload()
  } else {
    window.location.reload()
  }
}

// 降级刷新方案
const fallbackRefresh = () => {
  const url = new URL(window.location.href)
  url.searchParams.set('_t', Date.now())
  window.location.href = url.toString()
}

// 检测 Electron 环境
const checkElectronEnv = () => {
  isElectron.value = !!window.electronAPI
  if (isElectron.value) {
    console.log('Running in Electron with API:', window.electronAPI)
  }
}

// 生命周期
onMounted(() => {
  checkElectronEnv()

  if (isElectron.value) {
    document.addEventListener('keydown', handleKeydown)
    // 通知主进程页面已加载
    window.electronAPI?.log?.('Vue 3 app loaded')
  }
})

onBeforeUnmount(() => {
  if (isElectron.value) {
    document.removeEventListener('keydown', handleKeydown)
  }
})

</script>